<template>
    <div class="g-position">
        <div class="toast-con">
            <div class="toast-icon"></div>
            <p class="toast-title">{{title}}</p>
            <p class="toast-tips">{{tips}}</p>
            <div class="position-btn" @click="goPisition">重新定位</div>
            <div class="cancel" @click="cancel">取消</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PositionToast',
    data(){
        return{

        }
    },
    props:{
        title:{
            default:'标题'
        },
        tips:{
            default:'提示内容'
        },

    },
    methods:{
        goPisition(){
            this.$emit('goPosition');
        },
        cancel(){
            this.$emit('cancelToast')
        }
    }
}
</script>

<style lang="scss" scoped>
    .g-position{
        width: 100%;
        height: 100%;
        background-color: rgba($color: #000000, $alpha: 0.7);
        position: absolute;
        left: 0;
        top: 0;
    }
    .toast-con{
        width: 6.16rem;
        height: auto;
        background-color: #fff;
        border-radius: .12rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        .toast-icon{
            width: 1.4rem;
            height: 1.4rem;
            border-radius: 50%;
            border: 2px solid #fff;
            background: url('./../../static/img/position-logo.png') no-repeat center;
            background-size: .76rem .74rem;
            background-color: #EAEAEA;
            position: absolute;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        .toast-title{
            font-size: .34rem;
            color: #E02020;
            text-align: center;
            margin-top: .96rem;
        }
        .toast-tips{
            width: 4.76rem;
            color: #666666;
            font-size: .28rem;
            margin: .28rem auto 0;
            line-height: .44rem;
        }
        .position-btn{
            width: 5rem;
            height: .88rem;
            line-height: .88rem;
            text-align: center;
            color: #fff;
            font-size: .32rem;
            background-color: #53C1FF;
            margin: .5rem auto 0;
            border-radius: .08rem;
        }
        .cancel{
            width: 5rem;
            height: .88rem;
            line-height: .88rem;
            text-align: center;
            color: #8C8C80;
            font-size: .32rem;
            margin: .2rem auto 0;
            border-radius: .08rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/PositionToast.vue